import React from 'react';
import ServicePageTemplate from './ServicePageTemplate';
import { contentWritingServicesConfig } from './servicePageConfigs';

const ContentWritingServices = () => (
  <ServicePageTemplate {...contentWritingServicesConfig} />
);

export default ContentWritingServices;
